import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setOrderFilterForm } from "../../../slices/orders/orderSlice";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { ORD_FROM_DATE, ORD_TO_DATE } from "../../../Utils/FilterDateKeys";
import { CiSearch } from "react-icons/ci";

const OrderFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.order.filter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setOrderFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setOrderFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const orderOptions = [
    { value: "PAYMENT_SUCCESS", label: "Payment Success" },
    { value: "PAYMENT_FAILED", label: "Payment Failed" },
    { value: "PAYMENT_PENDING", label: "Payment Pending" },
    // { value: "PROPOSAL_PENDING", label: "Proposal Pending" },
    { value: "CANCELLED", label: "Cancelled" },
    { value: "COMPLETED", label: "Completed" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                {" "}
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Code, Member..."
                name="filter_ref"
                id="code"
                className="order-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>

          <Form.Group as={Col} className="col-md-4">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date range"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[ORD_FROM_DATE]
                  ? new Date(filterForm[ORD_FROM_DATE])
                  : null,
                filterForm[ORD_TO_DATE]
                  ? new Date(filterForm[ORD_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setOrderFilterForm,
                  ORD_FROM_DATE,
                  ORD_TO_DATE
                )
              }
            />
          </Form.Group>

          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="Status"
              name="status"
              options={orderOptions}
              value={
                orderOptions.find((itm) => itm.value === filterForm.status) ||
                null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default OrderFilter;
